import React, { FC } from 'react';
import { Popover } from '@barges/react';

import classes from './classes.module.scss';

type Props = {
  title: string;
  onClose: () => void;
};

export const AlertModal: FC<Props> = ({ title, onClose }) => (
  <Popover
    isOpen
    centered
    renderTitle={ () => <h6 className={ classes.title }>{title}</h6> }
    className={ classes.alertModal }
  >
    <button type="button" className={ classes.btn } onClick={ onClose }>OK</button>
  </Popover>
);
